const locale = {
  'shoppingCart.title.shoppingCart': '购物车',
  'shoppingCart.text.total': `合计：`,
  'shoppingCart.text.totalContent': `{total} 个SKU， 共 {totalCount} 件商品`,
  'shoppingCart.button.deleteCommodity': `删除商品`,
  'shoppingCart.modal.deleteCommodity': `是否确定删除选中的商品?`,
  'shoppingCart.button.clearQuantity': `重置数量`,
  'shoppingCart.modal.clearQuantity': `是否确定重置选中的商品的数量?`,
  'shoppingCart.button.exportSelected': `导出选中`,
  'shoppingCart.notification.export.message': `已导出选中商品`,
  'shoppingCart.notification.export.description': `可在浏览器下载中查看`,
  'shoppingCart.import.rule1': '1.支持导入格式为xlsx的文件',
  'shoppingCart.import.rule2': '2.上传文件可以导入更新的列表可参考下表，其中带*标识的列必填',
  'shoppingCart.import.rule3': '3.导入确认后更新已存在的零件号的数量',
  'shoppingCart.button.batchUpdateQuantity': '批量更新数量',
  'shoppingCart.message.emptyCart': '购物车数据为空时，不能批量更新数据。',
  'shoppingCart.message.emptyUpdateData': '更新数据为空时，不能批量更新数据。',
  'shoppingCart.import.partNumber': '零件号',
  'shoppingCart.import.brand': '配件品牌',
  'shoppingCart.import.quantity': '数量',
  'shoppingCart.message.invalidCheckedCartItems': '有商品数量不符合要求符合要求，请检查',
  'shoppingCart.message.differentStoreCartItems': '您一次只能从一家店铺下单',
};

export default locale;
